import {
  ContainerExportFormDefaultValues,
  ContainerExportFormProps,
  ContainerExportFormRawValues,
  ContainerExportFormType
} from "./ContainerExportForm";
import {useForm} from "@mantine/form";
import {getRequiredObjectId} from "@ots-frontend/ots-data";

const getInitialValues = (defaultValues: ContainerExportFormDefaultValues | undefined): ContainerExportFormRawValues => {
  return {
    companies: defaultValues?.companies?.map(getRequiredObjectId),
    wellMappingKey: defaultValues?.wellMappingKey,
    containerMappingKey: defaultValues?.containerMappingKey,
    containerMappingKey2: defaultValues?.containerMappingKey2,
  }
}

export type UseContainerExportFormProps = Pick<ContainerExportFormProps, 'defaultValues'> & {}

export function useContainerExportForm(props: UseContainerExportFormProps): ContainerExportFormType {
  const {
    defaultValues
  } = props

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
  })

  return form
}
